export const anchorLevel = [
  "",
  require("../assets/img/anchor-level/1@2x.png"),
  require("../assets/img/anchor-level/2@2x.png"),
  require("../assets/img/anchor-level/3@2x.png"),
  require("../assets/img/anchor-level/4@2x.png"),
  require("../assets/img/anchor-level/5@2x.png"),
  require("../assets/img/anchor-level/6@2x.png"),
  require("../assets/img/anchor-level/7@2x.png"),
  require("../assets/img/anchor-level/8@2x.png"),
  require("../assets/img/anchor-level/9@2x.png"),
  require("../assets/img/anchor-level/10@2x.png"),
  require("../assets/img/anchor-level/11@2x.png"),
  require("../assets/img/anchor-level/12@2x.png"),
  require("../assets/img/anchor-level/13@2x.png"),
  require("../assets/img/anchor-level/14@2x.png"),
  require("../assets/img/anchor-level/15@2x.png"),
  require("../assets/img/anchor-level/16@2x.png"),
  require("../assets/img/anchor-level/17@2x.png"),
  require("../assets/img/anchor-level/18@2x.png"),
  require("../assets/img/anchor-level/19@2x.png"),
  require("../assets/img/anchor-level/20@2x.png"),
];

export const userLevel = (level) => {
  switch (level) {
    case 0:
      return require("../assets/img/level1/lv0.png");
    case 1:
      return require("../assets/img/level1/lv1.png");
    case 2:
      return require("../assets/img/level1/lv2.png");
    case 3:
      return require("../assets/img/level1/lv3.png");
    case 4:
      return require("../assets/img/level1/lv4.png");
    case 5:
      return require("../assets/img/level1/lv5.png");
    case 6:
      return require("../assets/img/level1/lv6.png");
    case 7:
      return require("../assets/img/level1/lv7.png");
    case 8:
      return require("../assets/img/level1/lv8.png");
    case 9:
      return require("../assets/img/level1/lv9.png");
    case 10:
      return require("../assets/img/level1/lv10.png");
    case 11:
      return require("../assets/img/level1/lv11.png");
    case 12:
      return require("../assets/img/level1/lv12.png");
    case 13:
      return require("../assets/img/level1/lv13.png");
    case 14:
      return require("../assets/img/level1/lv14.png");
    case 15:
      return require("../assets/img/level1/lv15.png");
    case 16:
      return require("../assets/img/level1/lv16.png");
    case 17:
      return require("../assets/img/level1/lv17.png");
    case 18:
      return require("../assets/img/level1/lv18.png");
    case 19:
      return require("../assets/img/level1/lv19.png");
    case 20:
      return require("../assets/img/level1/lv20.png");
    case 21:
      return require("../assets/img/level1/lv21.png");

    default:
      return require("../assets/img/level1/lv0.png");
  }
};
